import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

const STATUS_COLOR = {
  "Presente": "bg-emerald-500/20 text-emerald-300 border-emerald-500/30",
  "Ausente": "bg-red-500/20 text-red-300 border-red-500/30",
  "Ausente justificado": "bg-amber-500/20 text-amber-300 border-amber-500/30",
};

export default function Attendance() {
  const [records, setRecords] = useState([]);
  useEffect(() => { api.get("/attendance").then(r => setRecords(r.data)).catch(() => {}); }, []);
  const total = records.length;
  const present = records.filter(r => r.status === "Presente").length;
  const pct = total ? Math.round((present / total) * 100) : 0;

  return (
    <AppLayout kind="athlete">
      <h1 className="text-3xl sm:text-4xl text-white font-semibold mb-2">Frequência</h1>
      <p className="text-slate-400 mb-8">Histórico de presença nos treinos GSX.</p>
      <div className="grid sm:grid-cols-3 gap-4 mb-8">
        <Metric label="Presenças" value={present} />
        <Metric label="Total de treinos" value={total} />
        <Metric label="Taxa de frequência" value={`${pct}%`} highlight />
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {records.map(r => (
          <Card key={r.id} className="bg-transparent gsx-card-dark p-4" data-testid={`att-${r.id}`}>
            <div className="text-xs text-slate-400 uppercase tracking-widest">Treino</div>
            <div className="font-mono text-lg text-white">{r.date}</div>
            <span className={`inline-block mt-2 px-2 py-1 rounded text-xs border ${STATUS_COLOR[r.status]}`}>
              {r.status}
            </span>
            {r.note && <div className="text-xs text-slate-400 mt-2">{r.note}</div>}
          </Card>
        ))}
        {!records.length && <div className="text-sm text-slate-400 col-span-full">Sem registros de frequência.</div>}
      </div>
    </AppLayout>
  );
}

function Metric({ label, value, highlight }) {
  return (
    <div className="gsx-card-dark p-5">
      <div className="text-xs text-slate-400 uppercase tracking-widest">{label}</div>
      <div className={`font-mono text-3xl mt-1 ${highlight ? "text-amber-400" : "text-white"}`}>{value}</div>
    </div>
  );
}
